module.exports = __webpack_public_path__ + "static/media/05-shot-default.c30d7c83.png";